<template>
    <div class="estrutura-item">
        <div class="item-container" :class="{ 'has-children': hasChildren, 'is-open': isOpen }">
            <i :class="caretIcon" class="caret" @click.stop="toggle"></i>
            <!-- <span :class="classeProduto" class="tipo-produto"></span> -->
            <div class="item-description alinha-v" :title="item.desc ?? item.produto_desc">
                <a :href="urlProduto" target="_blank" @click.stop class="link-produto" title="Abrir no cadastro de produtos">
                    <span>{{ item.produto_codigo ?? item.produto_cod ?? item.cod }} - {{ item.desc ?? item.produto_desc ?? '—' }}</span>
                </a>
                <div v-if="item.qt != null && item.unidade" class="qtdUnidade">
                    <span>{{ item.qt }}</span>
                    <span>{{ item.unidade }}</span>
                </div>
            </div>
        </div>
        <div v-if="isOpen && hasChildren" class="child-items">
            <EstruturaItem
                v-for="(childItem, index) in item.filhos"
                :key="childItem.id ?? index"
                :item="childItem" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'EstruturaItem',
    props: {
        item: {
            type: Object,
            required: true,
        },
        iniciarAberto: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: this.iniciarAberto,
        };
    },
    computed: {
        hasChildren() {
            return Array.isArray(this.item?.filhos) && this.item.filhos.length > 0;
        },
        caretIcon() {
            if (!this.hasChildren) return 'bi-dash-square';
            return this.isOpen ? 'bi-caret-down-square' : 'bi-caret-right-square';
        },
        urlProduto() {
            const cod = this.item?.produto_cod ?? this.item?.produto_codigo ?? this.item?.id;
            if (!cod) return '#';
            const base =
                process.env.NODE_ENV === 'development'
                    ? 'http://localhost.thalamus.ind.br:8081'
                    : 'https://produtos.thalamus.ind.br';
            return `${base}/#/catalogo/produto/${cod}`;
        },
        classeProduto() {
            const tipo = this.item?.tipo?.nome ?? this.item?.produto_tipo ?? '';
            const n = String(tipo).toLowerCase();
            if (n.includes('matéria') || n.includes('embalagem')) return 'materia-prima';
            if (n.includes('processo')) return 'produto-processo';
            if (n.includes('acabado')) return 'produto-acabado';
            if (n.includes('lembrete')) return 'lembrete';
            return '';
        },
    },
    methods: {
        toggle() {
            if (this.hasChildren) this.isOpen = !this.isOpen;
        },
    },
};
</script>

<style scoped>
.estrutura-item {
    margin-bottom: 2px;
}

.item-container {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--cor-separador, #eee);
    padding: 5px 8px;
    max-width: 100%;
    gap: 0.35rem;
}

.item-container .caret {
    cursor: pointer;
}

.item-container .caret:hover {
    color: var(--cor-primaria);
}

.item-container:hover {
    background-color: var(--cor-primaria-fraca, rgba(0, 0, 0, 0.04));
}

.link-produto {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
}

.link-produto:hover {
    text-decoration: underline;
}

.item-description {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex: 1;
    min-width: 0;
    margin: 0 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.qtdUnidade {
    background-color: var(--cor-cinza, #f0f0f0);
    border-radius: 6px;
    padding: 2px 8px;
    font-size: 0.9em;
    white-space: nowrap;
}

.child-items {
    margin-left: 20px;
    padding-left: 8px;
    border-left: 1px solid var(--cor-separador, #eee);
}

.tipo-produto {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
    display: inline-block;
}

.materia-prima {
    background-color: white;
    border: 1px solid #000;
}

.produto-processo {
    background-color: #ffd900;
}

.produto-acabado {
    background-color: #00ff15;
}

.lembrete {
    background-color: red;
}

i {
    font-size: 15px;
}


.is-open .caret {
    color: var(--cor-primaria);
}
</style>
